module.exports = {
      id: "search-usage",
      viewBox: "0 0 20 20.051",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#search",
      toString: function () {
        return this.url;
      }
    }